import React, { useContext, useEffect, useState } from 'react';
import {
  Row,
  Col,
  Button,
  Form,
  InputGroup,
  ListGroup,
  Spinner,
  Badge,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faEnvelope,
  faTrashAlt,
  faPlus,
  faThList,
  faLayerGroup,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { UserContext } from '../../Context/UserContext';
import './searchbar.css';
import './commission.css';
import clientAxios from '../../clients/clientAxios';
import { searchClassroomByName } from '../../helpers/searchClassRoomByName';

export default function Selector({
  commissionSelected,
  commission,
  confirmDelete,
  addComission,
  crList,
  copyMails,
  activeDownFilter,
  setActiveDownFilter,
  crListLoading,
  setCrListLoading,
  setCommission,
  getAllClassrooms,
}) {
  const userLevel = useContext(UserContext);
  const [searchValue, setSearchValue] = useState('');
  const [viewAllClassrooms, setViewAllClassrooms] = useState(false);
  const [suggestionsVisible, setSuggestionsVisible] = useState(false);
  const [suggestions, setSuggestions] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (event) => {
    const value = event?.target?.value;
    setSearchValue(value);
    if (value && value.length >= 2) {
      setSuggestionsVisible(true);
    } else {
      setSuggestionsVisible(false);
    }
  };

  const handleCommission = async (classroomId) => {
    try {
      setIsLoading(true);
      const { data } = await clientAxios(
        `/classroom/getStudentsInClassroom/${classroomId}`
      );
      setCommission({
        ...data.data[0],
        mentor: data.data[0].mentor,
        helper: data.data[0].helper,
        timeFrom: data.data[0].timeFrom,
        timeTo: data.data[0].timeTo,
        course: data.data[0].course,
        schedule: data.data[0].schedule,
        isActive: data.data[0].isActive ? data.data[0].isActive : '',
        students: data.data[0].students,
        courseSummary: data.data[0].courseSummary,
        plan: data.data[0].plan,
        slackChannel: data.data[0].slackChannel
          ? data.data[0].slackChannel
          : '',
        _id: classroomId,
        published: data.data[0]?.published,
        initialDate: data.data[0]?.initialDate || '',
      });
      setSuggestionsVisible(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClearInput = () => {
    setSearchValue('');
    setSuggestionsVisible(false);
  };

  useEffect(() => {
    if (searchValue.length >= 2) {
      searchClassroomByName(setIsLoading, setSuggestions, searchValue);
    }
  }, [searchValue]);

  const hasSelectedCommission = Boolean(commission && commission.classroom);
  const totalStudentsCount = commission?.students?.length || 0;

  return (
    <div className='commission-header-bar mb-4'>
      <Row className='align-items-center'>
        {/* Left Side: Filter and Search */}
        <Col xs={12} lg={7} className='mb-3 mb-lg-0'>
          <Row className='align-items-center'>
            <Col xs={12} sm={4} className='mb-2 mb-sm-0'>
              <InputGroup size='sm'>
                <InputGroup.Prepend>
                  <InputGroup.Text className='bg-light border-right-0 text-muted font-weight-bold'>
                    Estado
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  as='select'
                  size='sm'
                  name='commissionChangedReason'
                  className='commission-input'
                  onChange={(e) => {
                    setActiveDownFilter(e.target.value);
                    setCrListLoading(true);
                  }}
                  value={activeDownFilter}
                >
                  <option value='active'>Activas</option>
                  <option value='down'>Finalizadas</option>
                  <option value=''>Todas</option>
                </Form.Control>
              </InputGroup>
            </Col>

            <Col xs={12} sm={8}>
              <div className='d-flex align-items-center'>
                <div className='search-bar-container flex-grow-1 mr-2'>
                  <InputGroup size='sm'>
                    <InputGroup.Prepend>
                      <InputGroup.Text className='bg-white border-right-0 text-muted'>
                        <FontAwesomeIcon icon={faSearch} />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      type='text'
                      size='sm'
                      className='border-left-0 commission-input'
                      placeholder='Buscar comisión por nombre...'
                      value={searchValue}
                      onChange={handleChange}
                    />
                    {searchValue && (
                      <InputGroup.Append>
                        <Button
                          variant='outline-secondary'
                          size='sm'
                          className='border-left-0'
                          onClick={handleClearInput}
                        >
                          <FontAwesomeIcon icon={faTimes} size='xs' />
                        </Button>
                      </InputGroup.Append>
                    )}
                  </InputGroup>

                  {suggestionsVisible && (
                    <ListGroup className='suggestions-list'>
                      {isLoading ? (
                        <ListGroup.Item className='text-center py-3'>
                          <Spinner
                            animation='border'
                            role='status'
                            size='sm'
                            variant='primary'
                          />
                          <span className='ml-2 text-muted small'>Buscando...</span>
                        </ListGroup.Item>
                      ) : suggestions ? (
                        <ListGroup.Item
                          action
                          onClick={() => {
                            setSearchValue(suggestions?.classroom);
                            handleCommission(suggestions?._id);
                          }}
                        >
                          <div className='font-weight-bold text-dark'>
                            {suggestions?.classroom}
                          </div>
                          {suggestions?.course && (
                            <small className='text-muted'>
                              {typeof suggestions.course === 'object'
                                ? suggestions.course.name
                                : suggestions.course}
                            </small>
                          )}
                        </ListGroup.Item>
                      ) : (
                        <ListGroup.Item className='text-muted small'>
                          No se encontraron coincidencias
                        </ListGroup.Item>
                      )}
                    </ListGroup>
                  )}
                </div>

                <Button
                  variant={viewAllClassrooms ? 'secondary' : 'outline-primary'}
                  size='sm'
                  className='d-inline-flex align-items-center'
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={() => {
                    getAllClassrooms();
                    setViewAllClassrooms(!viewAllClassrooms);
                    handleClearInput();
                  }}
                >
                  <FontAwesomeIcon icon={faThList} className='mr-1' />
                  {viewAllClassrooms ? 'Ocultar' : 'Ver todas'}
                </Button>
              </div>
            </Col>
          </Row>

          {viewAllClassrooms && (
            <Row className='mt-2'>
              <Col xs={12}>
                <InputGroup size='sm'>
                  <InputGroup.Prepend>
                    <InputGroup.Text className='bg-light text-muted font-weight-bold'>
                      <FontAwesomeIcon icon={faLayerGroup} className='mr-1' />
                      Comisión:
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    as='select'
                    size='sm'
                    name='commissionSelected'
                    autoComplete='on'
                    className='commission-input'
                    onChange={(obj) => commissionSelected(obj)}
                    disabled={crListLoading || crList.length === 0}
                  >
                    {crListLoading || crList.length === 0 ? (
                      <option hidden>Cargando comisiones...</option>
                    ) : (
                      <option value='' hidden>
                        Seleccione una comisión de la lista...
                      </option>
                    )}
                    {crList.map((i, a) => (
                      <option key={a} value={i._id} name={i.classroom}>
                        {i.classroom}
                      </option>
                    ))}
                  </Form.Control>
                </InputGroup>
              </Col>
            </Row>
          )}
        </Col>

        {/* Right Side: Actions */}
        <Col xs={12} lg={5} className='text-lg-right'>
          <div className='d-flex flex-wrap align-items-center justify-content-lg-end'>
            <Button
              className='mr-2 mb-1 shadow-sm'
              variant='info'
              size='sm'
              onClick={() => copyMails()}
              disabled={!commission?.students || commission?.students?.length === 0}
            >
              <FontAwesomeIcon icon={faEnvelope} className='mr-1' />
              Copiar Emails
            </Button>

            {(!userLevel || (userLevel && userLevel.level < 3)) && (
              <>
                <Button
                  className='mr-2 mb-1 shadow-sm'
                  variant='outline-danger'
                  size='sm'
                  onClick={() => confirmDelete()}
                  disabled={!commission?._id}
                >
                  <FontAwesomeIcon icon={faTrashAlt} className='mr-1' />
                  Eliminar
                </Button>

                <Button
                  className='mb-1 shadow-sm'
                  variant='success'
                  size='sm'
                  onClick={() => addComission()}
                >
                  <FontAwesomeIcon icon={faPlus} className='mr-1' />
                  Nueva Comisión
                </Button>
              </>
            )}
          </div>
        </Col>
      </Row>

      {/* Selected Commission Quick Banner */}
      {hasSelectedCommission && (
        <div className='d-flex flex-wrap align-items-center justify-content-between pt-3 mt-3 border-top'>
          <div className='d-flex align-items-center flex-wrap'>
            <span className='h5 mb-0 mr-2 text-dark font-weight-bold'>
              {commission.classroom}
            </span>
            <Badge
              variant={commission.isActive === 'done' ? 'secondary' : 'success'}
              className='mr-2'
              style={{ fontSize: '0.78rem', padding: '5px 9px' }}
            >
              {commission.isActive === 'done' ? 'Finalizada' : 'Activa'}
            </Badge>
            {commission.isRollingKid && (
              <Badge
                variant='warning'
                className='mr-2'
                style={{ fontSize: '0.78rem', padding: '5px 9px' }}
              >
                Rolling Kid
              </Badge>
            )}
            {commission.mode && (
              <Badge
                variant='info'
                className='mr-2'
                style={{ fontSize: '0.78rem', padding: '5px 9px' }}
              >
                {commission.mode}
              </Badge>
            )}
          </div>
          <div className='text-muted small font-weight-bold'>
            Total Alumnos: <span className='text-primary font-weight-bold'>{totalStudentsCount}</span>
          </div>
        </div>
      )}
    </div>
  );
}
